import React from 'react';
import { Box, Button, Flex, Heading, Stack, Spacer } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

import { ProfileCheckbox } from '../elements/ProfileCheckbox';
import { ProfileField } from '../elements/ProfileField';
import { ProfileSelect } from '../elements/ProfileSelect';
import { position } from '../data';
import { makeFields } from './utils';

export const Position = ({ state, setter, remove, id, onBlur }) => {
	const { name, title, country, city, hoursPerWeek, startDate, isCurrent, endDate } =
		makeFields(state, setter, position, onBlur);
	const endDateDisabled = state.isCurrent;
	return (
		<Box borderRadius="md" border="1px" borderColor="gray.200" p={4} mb={4}>
			<Flex>
				<Heading pb={6} fontSize={'lg'}>
					{state.name || 'Место работы'}
				</Heading>
				<Spacer />
				<Button
					leftIcon={<CloseIcon />}
					colorScheme="red"
					variant="solid"
					size="xs"
					name={id}
					onClick={remove}
				>
					Удалить
				</Button>
			</Flex>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...name} />
				<ProfileField pb={6} {...title} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileSelect pb={6} {...country} />
				<ProfileField pb={6} {...city} />
				<ProfileField pb={6} {...hoursPerWeek} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...startDate} />
				<ProfileField pb={6} {...{ ...endDate, isDisabled: endDateDisabled }} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileCheckbox pb={6} {...isCurrent} />
			</Stack>
		</Box>
	);
};
